exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-toggle,.tab-toggle [role=tablist]{width:100%}.tab-toggle [role=tablist] label>span>div{padding:6px 12px!important}.tab-toggle [data-testid^=badge-]{display:flex;align-items:center}.tab-toggle [data-testid^=badge-] span{background-color:#3775d0!important}", ""]);

// exports
